import React__default from 'react';
import { Loader } from '@grandvisionhq/common';
import { NonRxProductCTA } from '../NonRxProductCTA/NonRxProductCTA.js';
import { RxGlassesCTA } from '../RxGlassesCTA/RxGlassesCTA.js';
import { ChannelAvailability } from '../../../../types/product.js';
import { useProductData } from '../../../../context/ProductContext.js';

const CTA = ({ isLoading , shouldOpenConfigurator , buttonRef , handleConversionEvent , handleConfiguratorOpen , onAddToCartSuccess  })=>{
    const { activeVariant: { channelAvailability , sku  } , bookAppointmentRouteConfig , routes ,  } = useProductData();
    return /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, isLoading ? /*#__PURE__*/ React__default.createElement(Loader, null) : shouldOpenConfigurator ? /*#__PURE__*/ React__default.createElement(RxGlassesCTA, {
        action: channelAvailability === ChannelAvailability.ONLINE ? 'OPEN_CONFIGURATOR' : 'OPEN_CONFIGURATOR_UNAVAILABLE',
        buttonRef: buttonRef,
        handleConversionEvent: handleConversionEvent,
        onClickWhenOrderable: handleConfiguratorOpen,
        bookAppointmentRouteConfig: bookAppointmentRouteConfig
    }) : /*#__PURE__*/ React__default.createElement(NonRxProductCTA, {
        storesRoute: routes.stores,
        action: channelAvailability === ChannelAvailability.ONLINE ? 'ADD_TO_CART' : 'ADD_TO_CART_UNAVAILABLE',
        handleConversionEvent: handleConversionEvent,
        addToCartConfig: {
            activeSku: sku,
            onSuccess: onAddToCartSuccess
        }
    }));
};

export { CTA };
//# sourceMappingURL=Cta.js.map
